<template>
  <div :class="['player-box', 'player-box--layout' + windowNumber]">
    <div
      :class="['player-box__item', hasActive(wnd)]"
      :ref="'wnd_' + wnd"
      @dragover.prevent
      draggable="true"
      v-for="wnd in dragItem"
      @drop="drop($event, wnd)"
      @click="handleActiveWnd(wnd)"
      :key="wnd"
    ></div>
  </div>
</template>
<script>
import Vue from "vue";
import busVue from "@/common/utils/busVue";
import SmartPlayer from "./video-smallNew.vue";
import axios from "axios";
import mixin from "./mixin";

export default {
  name: "PlayerBox",
  mixins: [mixin],
  props: {
    msg: {
      type: String,
      default: () => "",
    },
    windowNumber: {
      type: Number,
      default: () => 4,
    },
  },
  data() {
    return {
      activeWnd: 1,
      playRecord: null,
      dragItem: [],
      iframeObj: null, //插件
      videoNum: 0,
      password: "",
      username: "",
      ipaddr: "",
      port: "",
      windowVideoArr: [], //测试宇视视频专用--缓存窗口信息
    };
  },
  created() {
    window.playLive = this.playLive;
    window.closePlayer = this.closePlayer;
    // this.queryPlatSystemList();
  },
  watch: {
    windowNumber(val) {
      let nowNum = this.dragItem.length;
      if (val > nowNum) {
        for (let i = nowNum + 1; i <= val; i++) {
          this.dragItem.push(i);
        }
      } else {
        this.activeWnd = 1;
        this.dragItem.splice(val, nowNum - val);
      }
      this.$nextTick(() => {
        this.dragChange();
      });
    },
  },
  computed: {
    totalWnd() {
      let wndArray = [];
      for (let i = 1; i <= this.windowNumber; i++) {
        wndArray.push(i);
      }
      return wndArray;
    },
  },

  mounted() {
    console.log(window, "=====window");
    //创建窗口
    for (let i = 1; i <= this.windowNumber; i++) {
      // if (!window.token) {
      //   this.$message.warning("请先登录");
      //   return;login
      // }
      this.dragItem.push(i);
      // this.creatWindow();
    }
    this.$nextTick(() => {
      //  this.creatWindow(); //新的创建窗口---宇视
      this.dragChange(); //原来创建窗口
    });
    this.login();
  },
  beforeDestroy() {
    this.closeAllVideo();
  },
  activated() {
    // 进入后重新播放
    for (let key in this.playRecord) {
      let removeKey = key;
      this.playRecord[removeKey].play();
      this.playRecord[removeKey].vpdAxios();
    }
  },
  deactivated() {
    // 离开后暂停
    for (let key in this.playRecord) {
      let removeKey = key;
      this.playRecord[removeKey].pause();
      this.playRecord[removeKey].clearSetTime();
    }
  },
  methods: {
    //播放实况
    playLiveVideo(item, index) {
      this.creatWindow(item, index).then((res) => {
        console.log(res, "====idres");
        this.playLive(this.iframeObj.id, item, index);
        this.$emit("playVideoReady");
      });

      console.log("创建窗口", this.windowVideoArr);
    },
    creatWindow(data, index) {
      return new Promise((resolve) => {
        if (!window.token) {
          this.$message.warning("插件未登录");
          return;
        }
        this.iframeObj = imosSdk.createPanelWindow();
        console.log(this.iframeObj.id, "==create==playLiveVideo");
        // this.windowVideoObj.push(this.iframeObj.id);
        // console.log(this.windowVideoObj);
        // 如果窗格创建已经到达上限
        if (this.iframeObj === null) {
          return;
        }
        const videoItem = {
          type: 4,
          btnId: ["close"],
        };
        imosSdk.hiddenVideoBtn(this.iframeObj.id, videoItem, function (res) {
          console.log(res);
        });
        let divDom = document.createElement("div");
        divDom.classList.add("iframe-main", data.thirdCameraId);
        imosSdk.addTitleBtn(
          this.iframeObj.id,
          {
            id: "closeBtn" + index,
            className: "closeBtn",
            iconUrl: "x",
            tip: "关闭",
          },
          () => {
            this.playStop(this.iframeObj.id);
            console.log("自定义按钮点击了");
          },
          function (e) {
            console.log(e);
          }
        );
        // btn=getElementsByClassName('close-btn')
        // btn.onClick(()=>)
        const wnd = index ? this.destroyVideo(index) : this.getFreeWnd();
        console.log(wnd, "wnd=======");
        let videoDom =
          document.getElementsByClassName("player-box__item")[wnd - 1];
        divDom.appendChild(this.iframeObj);
        videoDom.appendChild(divDom);
        divDom = null;
        // this.createSpeDiv(this.iframeObj, data);
        let obj = this.savePlayInfo(this.iframeObj, data, wnd);
        this.windowVideoArr.push(obj);
        resolve(this.iframeObj);
      });
    },
    //关闭播放器---销毁窗口信息
    playStop(iframeID) {
      console.log(iframeID, "====playStop");
      imosSdk.playStop(iframeID, (result) => {
        console.log(result, "===playStopresult");
        if (result.ErrCode === 0) {
          let arr = this.windowVideoArr.concat();
          arr.forEach((item, index) => {
            if (item.iframeID == iframeID) {
              this.windowVideoArr.splice(index, 1);
              let deleteDom = document.getElementById(item.iframeID).parentNode;
              deleteDom.parentNode.removeChild(deleteDom);
              console.log(deleteDom, this.playRecord, "====deleteDom");
              let obj = Object.assign(this.playRecord);

              console.log(obj, this.playRecord, "====deleteDom");
              if (obj) {
                console.log("进入方法");
                let val = null;
                for (val in obj) {
                  if (obj[val].id == item.iframeID) {
                    console.log("frame相等");
                    obj[val].id == item.iframeID
                      ? delete this.playRecord[val]
                      : "";
                  }

                  console.log(this.playRecord, "this.playRecord--end");
                }

                // obj.forEach((el, index) => {
                //   el["wnd" + "_" + index].indexOf(item.iframeID) > 0
                //     ? delete this.playRecord["wnd" + "_" + index + 1]
                //     : "";
                // });
              }
              //  delete this.playRecord[]
            }
          });
        } else {
          console.log("执行失败" + result.ErrMsg);
        }
      });
    },
    // 缓存已播放直播的窗口信息
    savePlayInfo(component, data, wnd) {
      let obj = {
        index: wnd,
        thirdCameraId: data.thirdCameraId,
        iframeID: component.id,
      };
      console.log(obj, "==============");
      if (!this.playRecord) {
        this.playRecord = {};
      }
      this.playRecord[`wnd_${wnd}`] = component;
      console.log(this.playRecord)
      return obj;
      // if (!this.playRecord) {
      //   this.playRecord = {};
      // }
      // this.playRecord[`wnd_${wnd}`] = component;
    },
    // 获取当前播放中可用空闲窗口
    getFreeWnd() {
      console.log("空闲窗口", this.activeWnd, this.playRecord);
      const _activeKey = `wnd_${this.activeWnd}`;
      if (!this.playRecord || !this.playRecord[_activeKey])
        return this.activeWnd;
      // 当前选中窗口是否有视频播放
      // if () return this.activeWnd;
      const useWnd = Object.keys(this.playRecord).length;
      console.log(useWnd, "====uaseArry");
      if (useWnd < this.windowNumber) {
        // 依次播放
        const useArray = Object.keys(this.playRecord).map(
          (v) => +v.split("_")[1]
        );
        console.log(
          this.validFreeWnd(useArray),
          "====this.validFreeWnd(useArray)"
        );
        return this.validFreeWnd(useArray);
      }
      // 关闭当前激活的窗口--超出默认替换焦点窗口
      this.playRecord[_activeKey].close();
      // this.playRecord[_activeKey].$off();
      // this.playRecord[_activeKey].$destroy();
      this.playRecord[_activeKey] = null;
      delete this.playRecord[_activeKey];
      // console.log(_activeKey)
      return this.activeWnd;
    },
    // "<p>" +
    // item.name +
    // "<button onclick=\"playLive('" +
    // iframeObj.id +
    // "'," +
    // this.videoNum +
    // ')">播放实况</button></p>';
    createSpeDiv(iframeObj, item) {
      console.log("itemcretw", item);
    },
    // 元素替换
    dragChange() {
      let div = document.querySelectorAll(".player-box__item");
      let container = null;
      for (let i = 0; i < div.length; i++) {
        div[i].ondragstart = function () {
          container = this;
        };
        div[i].ondragover = function () {
          event.preventDefault();
        };
        div[i].ondrop = function () {
          if (container != null && container != this) {
            let temp = document.createElement("div");
            let domF = document.querySelector(".player-box");
            domF.replaceChild(temp, this);
            domF.replaceChild(this, container);
            domF.replaceChild(container, temp);
          }
        };
      }
    },
    playLive(id, item, wnd) {
      console.log("playlive", wnd, item);
      imosSdk.playLive(
        id,
        item.thirdCameraId,
        item.name,
        (res) => {
          if (res.ErrCode == 0) {
            this.$emit("playSuccess", id, item);
            this.$message.success(item.name + "正在窗口" + wnd + "播放");
          }
          console.log(res, "=====播放回调");
        },
        2
      );
      // cameraCode = null;
    },
    // 视频录像回放
    playBackVideo(params, index) {
      this.creatWindow(params.deviceObj, index).then((res) => {
        imosSdk.playRecord(
          res,
          params.deviceObj.thirdCameraId,
          params.deviceObj.name + "录像回放",
          new Date(params.startTime),
          new Date(params.endTime),
          (result) => {
            // this.$refs[`wnd_${wnd}`][0].removeChild(dom);
            if (result.ErrCode === 0) {
              this.$emit("playBackOk", params);
              console.log("播放成功", result);
            } else {
              // const dom2 = this.handlePlayerLoading(result.ErrMsg, wnd);
              console.log("播放失败" + result.ErrMsg);
            }
          },
          1
        );
      });

      //原来录像播放start
      // const wnd = index ? this.destroyVideo(index) : this.getFreeWnd();
      // const dom = this.handlePlayerLoading("视频请求中...", wnd);
      // const param = {
      //   deviceId: option.deviceId,
      //   startTime: Math.ceil(option.startTime),
      //   endTime: Math.ceil(option.endTime),
      // };
      // this.$fetch(
      //   this.$api.common.video.queryPlayBackVideoEventRtsp,
      //   param
      // ).then((res) => {
      //   this.$refs[`wnd_${wnd}`][0].removeChild(dom);
      //   if (res.success) {
      //     if (!res.returnObj.url || !res.returnObj.url.flv) {
      //       const dom3 = this.handlePlayerLoading("视频云播放地址为空", wnd);
      //       this.$log.warn(
      //         "当前摄像机录像回放播放地址为空，摄像机信息为：",
      //         param
      //       );
      //       return;
      //     }
      //     const _data = res.returnObj;
      //     const playUrl = _data.url.flv;
      //     option.videoType = "back";
      //     option.streamId = res.returnObj.stream_id || "";
      //     this.loadVideo(playUrl, wnd, option, "flv");
      //   } else {
      //     const dom2 = this.handlePlayerLoading(res.msgContent, wnd);
      //   }
      // });
      //end
    },
    initWnd() {
      for (let i = 1; i <= this.windowNumber; i++) {
        this.wndArray.push(i);
      }
    },
    // 当前激活的窗口高亮
    hasActive(wnd) {
      return this.activeWnd === wnd ? "player-box__item--active" : "";
    },
    // 激活当前窗口
    handleActiveWnd(wnd) {
      this.activeWnd = wnd;

      this.$emit("handleClickWnd", wnd);
      console.log(this.activeWnd, "===activeWnd");
    },
    // 回显摄像机
    showIconVideo() {
      let showList = [];
      for (let key in this.playRecord) {
        showList.push({
          deviceId: this.playRecord[key].deviceInfo.thirdCameraId,
        });
      }
      return showList;
    },
    // 关闭所有
    closeAllVideo() {
      // console.log(this.playRecord);
      // for (let key in this.playRecord) {
      //   let removeKey = key;
      //   delete this.playRecord[removeKey];
      // }
      let arr = this.windowVideoArr.concat();
      arr.forEach((item) => {
        this.playStop(item.iframeID);
      });
      // this.windowVideoArr.forEach((item) => {
      //   console.log(item, "====item");
      //   imosSdk.playStop(item.iframeObj, (res) => {
      //     console.log("关闭所有成功！", res);
      //   });
      // });
      // for (let i = 0; i < this.windowNumber; i++) {
      //   // 关闭loading
      //   document.querySelector(".player-loading")
      //     ? document.querySelector(".player-loading").remove()
      //     : "";
      //   // document.querySelector('.smart-player__loading') ?
      //   //   document.querySelector('.smart-player__loading').remove() : "";
      //   // 关闭子播放器
      //   document.querySelector(".smart-player")
      //     ? document.querySelector(".smart-player").remove()
      //     : "";
      // }
    },
    // 拖拉摄像机播放
    drop(event, index) {
      console.log(event, index, "drop");
      let option = event.dataTransfer.getData("item");
      option
        ? this.$emit("dropCall", {
            option: JSON.parse(option),
            index: index,
          })
        : "";
    },

    // 销毁video
    destroyVideo(index) {
      let cutKey = `wnd_${index}`;
      if (this.playRecord) {
        if (!this.playRecord[cutKey]) return index;
        this.playRecord[cutKey].close();
        // this.playRecord[cutKey].$off();
        // this.playRecord[cutKey].$destroy();
        // this.playRecord[cutKey] = null;
        delete this.playRecord[cutKey];
      }
      return index;
    },
    // 替换视频源
    cutPlayLiveVideo(info, index, type) {
      this.playLiveVideo(info, index, type);
    },
    // 获取任意一个空闲窗口
    validFreeWnd(useArray) {
      let wnd = 0;
      for (let i of this.totalWnd) {
        if (useArray.some((v) => i === v)) {
          continue;
        } else {
          wnd = i;
          break;
        }
      }
      return wnd;
    },
    // 销毁或创建loding-sping
    handlePlayerLoading(message, wnd) {
      let dom = document.createElement("div");
      dom.className = "player-loading";
      dom.innerHTML += `<div class="player-loading_close" title="关闭" onclick="closePlayer(${wnd})"> <i class="el-icon-close"></i></div><div class="player-loading__spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>`;
      dom.innerHTML += `<p>${message}</P>`;
      this.$refs[`wnd_${wnd}`][0].innerHTML = "";
      this.$refs[`wnd_${wnd}`][0].appendChild(dom);
      return dom;
    },
    // 未展示子播放器时显示的关闭按钮
    closePlayer(wnd) {
      this.$refs[`wnd_${wnd}`][0].innerHTML = "";
      if (this.playRecord[`wnd_${wnd}`]) {
        this.playRecord[`wnd_${wnd}`].clearSetTime();
        this.playRecord[`wnd_${wnd}`].$off();
        this.playRecord[`wnd_${wnd}`].close();
        this.playRecord[`wnd_${wnd}`].$destroy();
        this.playRecord[`wnd_${wnd}`] = null;
        delete this.playRecord[`wnd_${wnd}`];
      }
    },
    // 批量抓拍
    localSnapAll(snapList) {
      this.$fetch(this.$api.common.video.localSnapList, snapList).then(
        (res) => {
          this.$emit("localSnapCall", res.returnObj);
          if (!res.success) {
            this.$message.error(res.msgContent);
          } else {
            this.$message({
              message: "抓拍成功",
              type: "success",
            });
            // this.$message({
            //   message: "抓拍成功，正在下载到本地",
            //   type: "success",
            // });
            // res.returnObj.forEach((el) => {
            //   this.downloadImage(el.img_url);
            // });
          }
        }
      );
    },
    downloadImage(imgsrc) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = "snap_" + new Date().getTime(); // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
  },
};
</script>
<style>
.iframe-main,
.imosSdk-video {
  height: 100% !important;
  width: 100% !important;
}
</style>
<style scoped lang="scss">
@import "~@src/common/assets/style/mixin";
:deep .imosSdk-video {
  width: 100% !important;
  height: 100% !important;
  border: none !important;
}
:deep .imosVideo-mask {
  background: #3a3a3a url("/images/theme/newDark/default.png") center no-repeat !important;
}
:deep .imosVideo-playPauseIcon {
  display: none !important;
}
.player-box {
  position: relative;
  .iframe-item {
    height: 100%;
    width: 100%;
  }

  .full-screen {
    width: 100% !important;
    height: 100% !important;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 5;
  }
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // padding: 5px;
  background-color: rgba($color: #000, $alpha: 0.5);
  &--layout4 {
    .player-box__item {
      width: 50%;
      height: 50%;
    }
  }
  &--layout6 {
    .player-box__item:first-child {
      width: 66.66%;
      height: 66.66%;
    }
    .player-box__item:nth-child(3) {
      position: absolute;
      top: 33.33%;
      right: 0;
    }
    .player-box__item {
      width: 33.33%;
      height: 33.33%;
    }
  }
  &--layout9 {
    .player-box__item {
      width: 33.33%;
      height: 33.33%;
    }
  }
  &--layout16 {
    .player-box__item {
      width: 25%;
      height: 25%;
    }
  }
  &__item {
    width: 100%;
    height: 100%;
    background: #3a3a3a url("/images/theme/newDark/default.png") no-repeat;
    background-size: 100% 100%;
    border: rgba(#000, 0.5) solid 1px;
    transition: all 0s ease-in;
    position: relative;
    &--active {
      border-color: royalblue;
    }
  }
}
</style>
